import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import infra from '@/util/infra'
import 'bootstrap'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/scss/main.scss'
import { axios } from './http'
import VueAxios from 'vue-axios'
import VueDayjs from 'vue-dayjs-plugin'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br.js'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { VueMaskDirective, VueMaskFilter } from 'v-mask'
import VueIntercom from 'vue-intercom'
import { formatarPorcentagem, formatarValorMonetario, formatarData } from './util/filtros'
import ContextManagerPlugin from '@/plugins/contextManagerPlugin'
import ClarityPlugin from '@/plugins/clarityPlugin'
import VueGtm from '@gtm-support/vue2-gtm'
import PluginInitializer from '@/plugins/PluginInitializer'

infra.controleRefreshPagina()
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueAxios, axios)
Vue.use(VueDayjs)
Vue.use(CKEditor)
Vue.use(ContextManagerPlugin)
Vue.component('v-select', vSelect)
Vue.component('treeSelect', Treeselect)
Vue.directive('mask', VueMaskDirective)
Vue.filter('VMask', VueMaskFilter)
Vue.filter('formatarPorcentagem', formatarPorcentagem)
Vue.filter('formatarValorMonetario', formatarValorMonetario)
Vue.filter('formatarData', formatarData)

const pluginInitializer = new PluginInitializer(Vue, Vue.prototype.$contextManager)
pluginInitializer.register(VueIntercom, { keyName: 'appId', configKey: 'intercomId', options: {} })
pluginInitializer.register(VueGtm, { keyName: 'id', configKey: 'gtmId', options: {} })
pluginInitializer.register(ClarityPlugin, { keyName: 'id', configKey: 'clarityId', options: {} })

pluginInitializer.initialize()

Vue.config.productionTip = false
window._Vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export const main = window._Vue
